module.exports = __webpack_public_path__ + "img/Willing Risk Taker.6911d8c7.svg";